/** What Siesta is asked to do when a client's Cashflows tab is empty. */
export const CASHFLOWS_SIESTA_PROMPT =
  'Please read this profile’s documents and record the income, expenditure and future life ' +
  'events you find, with their amounts and frequencies. Ask me for anything you cannot find.';

/**
 * What Siesta is asked for on a household tab. The client tab's prompt reads "this profile's
 * documents", which Siesta answers for one person — on a family tab that quietly fills in one
 * member and leaves the rest empty, so the household says so itself.
 */
export const FAMILY_CASHFLOWS_SIESTA_PROMPT =
  'Please read the documents of every member of this household and record the income, ' +
  'expenditure and future life events you find for each of them, with their amounts and ' +
  'frequencies. Ask me for anything you cannot find.';

/**
 * Names the reads that actually failed. Blaming all three when only the life events timed out
 * sends the adviser looking for a problem with figures that are sitting there.
 */
export function failedCashflowsLabel(failed: {
  incomes: boolean;
  expenditures: boolean;
  lifeEvents: boolean;
}): string {
  const kinds = [
    failed.incomes && 'income',
    failed.expenditures && 'expenditure',
    failed.lifeEvents && 'life events',
  ].filter((kind): kind is string => !!kind);
  if (kinds.length === 0) return 'cashflows';
  return new Intl.ListFormat('en-GB', { style: 'long', type: 'conjunction' }).format(kinds);
}
